import { Box, Typography } from '@mui/material';

import { TruncatedBox } from '@/components';
import { Chapter, Referrer, UserChapterProgress } from '@/types';

import { EpisodeChapterTile } from '..';

export type EpisodeChapterListComponentProps = {
  chapters: Chapter[];
  episodeChaptersProgress: UserChapterProgress[];
  referrer: Referrer;
};

export const EpisodeChapterList = ({
  chapters,
  episodeChaptersProgress,
  referrer,
}: EpisodeChapterListComponentProps) => {
  return (
    <TruncatedBox truncatedContentHeight={650}>
      <Box sx={styles.listContainer}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Chapters & Quizzes
        </Typography>
        {chapters?.map((chapter, index) => (
          <EpisodeChapterTile
            key={index}
            index={index}
            chapter={chapter}
            userChapter={episodeChaptersProgress?.find(
              uc => uc.id === chapter.chapterId,
            )}
            referrer={referrer}
          />
        ))}
      </Box>
    </TruncatedBox>
  );
};

const styles = {
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 4,
  },
};
